import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

/** Full Chilean long date: "10 de abril de 2026". */
export function formatLongDate(input: string | Date): string {
  const date = typeof input === 'string' ? parseISO(input) : input;
  return format(date, "d 'de' MMMM 'de' yyyy", { locale: es });
}

/** Short civic date: "10 abr 2026". */
export function formatShortDate(input: string | Date): string {
  const date = typeof input === 'string' ? parseISO(input) : input;
  return format(date, "d MMM yyyy", { locale: es });
}

/** Compact numeric date: "10/04/2026". */
export function formatNumericDate(input: string | Date): string {
  const date = typeof input === 'string' ? parseISO(input) : input;
  return format(date, 'dd/MM/yyyy', { locale: es });
}

/** "hace 2 dias" relative time. */
export function formatRelative(input: string | Date): string {
  const date = typeof input === 'string' ? parseISO(input) : input;
  return formatDistanceToNow(date, { locale: es, addSuffix: true });
}

/** Period "2026-04" to "Abril 2026". */
export function formatPeriodo(periodo: string): string {
  const [year, month] = periodo.split('-');
  const monthIdx = month ? parseInt(month, 10) - 1 : 0;
  const date = new Date(parseInt(year || '2000', 10), monthIdx, 1);
  return format(date, "MMMM yyyy", { locale: es }).replace(/^./, (c) => c.toUpperCase());
}
